"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * generic reducer generated default generic that handle object AND string
 * with no care for any particular action.type
 *
 * To use it, just add the name to stringReducers or to objectReducers,
 * then it will be created in generic object.
 * You just use it as generic.name anywhere it's needed.
 *
 * @type {string[]}
 */
var stringReducers = ['_csrf'];
// res.locals data added by react-engine by default, so we have to add nonce, anomalyDetection, isLoggedOut here
var objectReducers = [
    'baseUrls',
    'content',
    'links',
    'locality',
    'pageInfo',
    'nonce',
    'isLoggedOut',
    'fpti',
    'features',
    'config',
    'experiments',
    'navigation',
    'ui',
    'notificationPreferences',
    'user',
    'anomalyDetection',
    'sellerPreferences'
];
function createObjectReducer(name) {
    return function (state, action) {
        if (state === void 0) { state = {}; }
        return action[name] ? Object.assign({}, state, action[name]) : state;
    };
}
exports.createObjectReducer = createObjectReducer;
function createStringReducer(name) {
    return function (state, action) {
        if (state === void 0) { state = ''; }
        return action[name] ? action[name] : state;
    };
}
exports.createStringReducer = createStringReducer;
var generic = {};
stringReducers.reduce(function (prev, name) {
    prev[name] = createStringReducer(name);
    return prev;
}, generic);
objectReducers.reduce(function (prev, name) {
    prev[name] = createObjectReducer(name);
    return prev;
}, generic);
exports.default = generic;
